import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface BlockUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function blockUserAction(userId: string): Promise<ApiResponse<BlockUserResponse>> {
  return api.patch<ApiResponse<BlockUserResponse>>(`/users/${userId}/block`)
}
